/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Flex,
  Grid,
  SwitchField,
  TextField,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { getAdDetail } from "../graphql/queries";
import { updateAdDetail } from "../graphql/mutations";
const client = generateClient();
export default function AdDetailUpdateForm(props) {
  const {
    id: idProp,
    adDetail: adDetailModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    playOrder: "",
    numberOfAds: "",
    minutesOfAds: "",
    isSkippable: false,
    pricing: "",
  };
  const [playOrder, setPlayOrder] = React.useState(initialValues.playOrder);
  const [numberOfAds, setNumberOfAds] = React.useState(
    initialValues.numberOfAds
  );
  const [minutesOfAds, setMinutesOfAds] = React.useState(
    initialValues.minutesOfAds
  );
  const [isSkippable, setIsSkippable] = React.useState(
    initialValues.isSkippable
  );
  const [pricing, setPricing] = React.useState(initialValues.pricing);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = adDetailRecord
      ? { ...initialValues, ...adDetailRecord }
      : initialValues;
    setPlayOrder(cleanValues.playOrder);
    setNumberOfAds(cleanValues.numberOfAds);
    setMinutesOfAds(cleanValues.minutesOfAds);
    setIsSkippable(cleanValues.isSkippable);
    setPricing(cleanValues.pricing);
    setErrors({});
  };
  const [adDetailRecord, setAdDetailRecord] = React.useState(adDetailModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? (
            await client.graphql({
              query: getAdDetail.replaceAll("__typename", ""),
              variables: { id: idProp },
            })
          )?.data?.getAdDetail
        : adDetailModelProp;
      setAdDetailRecord(record);
    };
    queryData();
  }, [idProp, adDetailModelProp]);
  React.useEffect(resetStateValues, [adDetailRecord]);
  const validations = {
    playOrder: [{ type: "Required" }],
    numberOfAds: [{ type: "Required" }],
    minutesOfAds: [{ type: "Required" }],
    isSkippable: [{ type: "Required" }],
    pricing: [{ type: "Required" }],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          playOrder,
          numberOfAds,
          minutesOfAds,
          isSkippable,
          pricing,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: updateAdDetail.replaceAll("__typename", ""),
            variables: {
              input: {
                id: adDetailRecord.id,
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "AdDetailUpdateForm")}
      {...rest}
    >
      <TextField
        label="Play order"
        isRequired={true}
        isReadOnly={false}
        value={playOrder}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              playOrder: value,
              numberOfAds,
              minutesOfAds,
              isSkippable,
              pricing,
            };
            const result = onChange(modelFields);
            value = result?.playOrder ?? value;
          }
          if (errors.playOrder?.hasError) {
            runValidationTasks("playOrder", value);
          }
          setPlayOrder(value);
        }}
        onBlur={() => runValidationTasks("playOrder", playOrder)}
        errorMessage={errors.playOrder?.errorMessage}
        hasError={errors.playOrder?.hasError}
        {...getOverrideProps(overrides, "playOrder")}
      ></TextField>
      <TextField
        label="Number of ads"
        isRequired={true}
        isReadOnly={false}
        type="number"
        step="any"
        value={numberOfAds}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              playOrder,
              numberOfAds: value,
              minutesOfAds,
              isSkippable,
              pricing,
            };
            const result = onChange(modelFields);
            value = result?.numberOfAds ?? value;
          }
          if (errors.numberOfAds?.hasError) {
            runValidationTasks("numberOfAds", value);
          }
          setNumberOfAds(value);
        }}
        onBlur={() => runValidationTasks("numberOfAds", numberOfAds)}
        errorMessage={errors.numberOfAds?.errorMessage}
        hasError={errors.numberOfAds?.hasError}
        {...getOverrideProps(overrides, "numberOfAds")}
      ></TextField>
      <TextField
        label="Minutes of ads"
        isRequired={true}
        isReadOnly={false}
        type="number"
        step="any"
        value={minutesOfAds}
        onChange={(e) => {
          let value = isNaN(parseFloat(e.target.value))
            ? e.target.value
            : parseFloat(e.target.value);
          if (onChange) {
            const modelFields = {
              playOrder,
              numberOfAds,
              minutesOfAds: value,
              isSkippable,
              pricing,
            };
            const result = onChange(modelFields);
            value = result?.minutesOfAds ?? value;
          }
          if (errors.minutesOfAds?.hasError) {
            runValidationTasks("minutesOfAds", value);
          }
          setMinutesOfAds(value);
        }}
        onBlur={() => runValidationTasks("minutesOfAds", minutesOfAds)}
        errorMessage={errors.minutesOfAds?.errorMessage}
        hasError={errors.minutesOfAds?.hasError}
        {...getOverrideProps(overrides, "minutesOfAds")}
      ></TextField>
      <SwitchField
        label="Is skippable"
        defaultChecked={false}
        isDisabled={false}
        isChecked={isSkippable}
        onChange={(e) => {
          let value = e.target.checked;
          if (onChange) {
            const modelFields = {
              playOrder,
              numberOfAds,
              minutesOfAds,
              isSkippable: value,
              pricing,
            };
            const result = onChange(modelFields);
            value = result?.isSkippable ?? value;
          }
          if (errors.isSkippable?.hasError) {
            runValidationTasks("isSkippable", value);
          }
          setIsSkippable(value);
        }}
        onBlur={() => runValidationTasks("isSkippable", isSkippable)}
        errorMessage={errors.isSkippable?.errorMessage}
        hasError={errors.isSkippable?.hasError}
        {...getOverrideProps(overrides, "isSkippable")}
      ></SwitchField>
      <TextField
        label="Pricing"
        isRequired={true}
        isReadOnly={false}
        type="number"
        step="any"
        value={pricing}
        onChange={(e) => {
          let value = isNaN(parseFloat(e.target.value))
            ? e.target.value
            : parseFloat(e.target.value);
          if (onChange) {
            const modelFields = {
              playOrder,
              numberOfAds,
              minutesOfAds,
              isSkippable,
              pricing: value,
            };
            const result = onChange(modelFields);
            value = result?.pricing ?? value;
          }
          if (errors.pricing?.hasError) {
            runValidationTasks("pricing", value);
          }
          setPricing(value);
        }}
        onBlur={() => runValidationTasks("pricing", pricing)}
        errorMessage={errors.pricing?.errorMessage}
        hasError={errors.pricing?.hasError}
        {...getOverrideProps(overrides, "pricing")}
      ></TextField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || adDetailModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || adDetailModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
